export default{
    //SCHEDULE INTERVIEW
    "question.error.refresh"               : "Spiacenti, l'orario da lei selezionato non è più disponibile. Scelga un altro orario di seguito",
    "question.error.char.exceeded"         : "Il testo del commento deve contenere meno di 500 caratteri.",
    
    "question.message.completed.1"         : "La ringraziamo per aver scelto l'orario dell'intervista. Abbiamo inviato un'e-mail dall'indirizzo qual@surveyhealthcareglobal.com per confermare l'orario e la data della sua sessione.",
    "question.message.italic"              : "Le chiediamo di leggere attentamente tutte le istruzioni e di contattare il responsabile di progetto addetto alla prenotazione in caso avesse domande da porre.",
    "question.message.completed.2"         : "Gli incentivi vengono accreditati dopo il completamento del progetto e la ricerca potrebbe protrarsi per varie settimane. Il responsabile di progetto addetto alla prenotazione le fornirà gli orari su richiesta.",
    "question.message.completed.3"         : "Per ritirarsi dall'intervista o per riprogrammarla, contatti l'indirizzo: qual@surveyhealthcareglobal.com e indichi il suo numero del progetto di conferma.",
    "question.message.overquota.1"         : "La ringraziamo per l’interesse dimostrato a partecipare oggi. Sfortunatamente, questo studio ha raggiunto il numero massimo di partecipanti prima del previsto e non possiamo accettare ulteriori risposte. In caso di cambiamenti, le faremo sapere. Saremo lieti di collaborare con lei in futuro.",
    "question.message.overquota.2"         : "La ringraziamo per il tempo che ci ha dedicato e per la sua collaborazione.",
    "question.message.error"               : "Potrebbe esserci un problema con la finalizzazione del suo appuntamento. Contatti il nostro responsabile di progetto addetto alla prenotazione scrivendo un'e-mail a qual@surveyhealthcareglobal.com, indicando il numero di progetto che trova nel suo invito.",

    "minutes" : "minuti",
    // NEW OR ADDED FROM OTHER FILES OR CONST
    "select.time.for.interview"            : "Selezioni un orario per l’intervista",
    "all.times.are.in"                     : "Tutti gli orari si riferiscono al fuso orario <>.",
    "question.time_slots.none"             : "Nessuno degli orari riportati sopra sono a me comodi. Specificherò la mia disponibilità di seguito.",
    "question.comments"                    : "Commenti",
    "scheduler.link.submit"                : "Inviare",
    "question.text_placeholder"            : "Inserisca qui la sua risposta...",
    // MONTHS
    "January"                              : "gennaio",
    "February"                             : "febbraio",
    "March"                                : "marzo",
    "April"                                : "aprile",
    "May"                                  : "maggio",
    "June"                                 : "giugno",
    "July"                                 : "luglio",
    "August"                               : "agosto",
    "September"                            : "settembre",
    "October"                              : "ottobre",
    "November"                             : "novembre",
    "December"                             : "dicembre",
    // DAYS OF THE WEEK
    "Monday"                               : "Lunedì",
    "Tuesday"                              : "Martedì",
    "Wednesday"                            : "Mercoledì",
    "Thursday"                             : "Giovedì",
    "Friday"                               : "Venerdì",
    "Saturday"                             : "Sabato",
    "Sunday"                               : "Domenica",
    
    // OPEN SLOTS
    "open.slots"                           : "fasce orarie aperte"
}